module.exports = __webpack_public_path__ + "img/scooter.c91a7bbb.png";